import { useEffect, useRef, useState } from 'react'
import UnAuthComponent from '../layout/unauth.component'
import { ArrowForwordIcon, FalconLogo, IncoreectIcon, LockGrayIcon, MessageIcon } from '../../icon';
import { ToasterTexts, appNote, buttonLabels } from '../shared/constants';
import { FormHelperText, InputAdornment, TextField } from '@mui/material';
import ButtonComponent from '../shared/button/button.component';
import { validateForm } from '../shared/form-validation';
import { SecureFileService } from '../../services/SecureFileService';
import { DisplayMediaIcon } from './display-media.component';
import SecureFileOtpVerficationComponent from './secure-file-otp-verification.component';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import * as docxPreview from "docx-preview";
import { UtilityService } from '../../services/UtilityService';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';


interface Props { }

const SecureFileEmailAuthentication = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const [email, setEmail] = useState<string>("")
    const [errors, setErrors] = useState({ Email: "" })
    const [fileName, setFileName] = useState<string>("")
    const [showLoader, setShowLoader] = useState<boolean>(false)
    const [verifyemailerror, setVerifyemailerror] = useState<string>("")
    const [isEmailSent, setIsEmailSent] = useState<boolean>(false)
    const [otp, setOtp] = useState<string>("")
    const [verifyOtpError, setVerifyOtpError] = useState<string>("")
    const [isValidOtp, setIsValidOtp] = useState<boolean>(false)
    const [showResendTimer, setResendTimer] = useState<boolean>(true)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [errorCount, setErrorCount] = useState<number>(0)
    const [fileId, setFileId] = useState<string>("")
    const [uri, setUri] = useState<string>("")
    const [blob, setBlob] = useState("")

    const containerRef = useRef(null);

    const handleChange = (name: any, value: any) => {
        validateForm({ [name]: value }, (errors) => {
            setErrors({ Email: errors["email"] });
        });
        setEmail(value)
    };

    const VerifyEmail = (e) => {
        setIsLoading(true)
        e.preventDefault();
        e.stopPropagation();
        setShowLoader(true)
        setVerifyOtpError("")
        let data = {
            "user_email": email,
            "file_name": fileName,
            "id": fileId
        }
        SecureFileService.verifyEmail(data).then((res) => {
            setIsLoading(false)
            setShowLoader(false)
            setIsEmailSent(true)
        }).catch((err) => {
            setIsLoading(false)
            setShowLoader(false)
            setVerifyemailerror(err.response.data.error)
            setIsEmailSent(false)
            console.log("err", err.response.data.error);
        })
    }

    const setOtpEmailTitle = () => {
        let a = email.charAt(0) + "**********" + email.substring(email.lastIndexOf("@") - 1)
        return `Enter the OTP received via email on ${a}`
    }

    const handleOtpChange = (otp: any) => {
        setOtp(otp)
    };

    const resendOtp = () => {
        setShowLoader(true);
        setResendTimer(false)
        let data = {
            "user_email": email,
            "file_name": fileName,
            "id": fileId
        }
        SecureFileService.verifyEmail(data).then((res) => {
            setToast(ToasterTexts.RESEND_OTP_SUCCESS, ToasterType.SUCCESS);
            setShowLoader(false);
            setResendTimer(true)

        }).catch((err) => {
            setToast(ToasterTexts.RESEND_OTP_FAILURE, ToasterType.DANGER);
        });
    };

    const verifyOtp = () => {
        setIsLoading(true)
        let data = {
            "user_email": email,
            "file_name": fileName,
            "id": fileId,
            "otp": otp
        }
        SecureFileService.verifyOTP(data).then(async (res) => {
            // if (res && HmacSignatureUtilities.verifySignature(res.data,res.headers["falkonsignature"])) {
            const readOnley = res.headers["read-only"]
            if (readOnley === "true") {
                if (UtilityService.getSecureFileMediaExtension(fileName).includes("vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                    const url = URL.createObjectURL(new Blob([res.data], { type: UtilityService.getSecureFileMediaExtension(fileName) }))
                    setTimeout(() => {
                        const buffer = res.data;
                        if (containerRef.current) {
                            containerRef.current.innerHTML = "";
                            docxPreview.renderAsync(buffer, containerRef.current, undefined, {
                                className: "docx-wrapper"
                            });
                        }
                    }, 1000)
                    setUri(url)
                }
                else {
                    setIsLoading(true)
                    const blob = new Blob([new Uint8Array(res.data)], { type: UtilityService.getSecureFileMediaExtension(fileName) });
                    const dataUrl = await blobToDataUrl(blob);
                    const url = URL.createObjectURL(blob);
                    setBlob(dataUrl)
                    setUri(url)
                }
            }
            else {
                const url = URL.createObjectURL(new Blob([res.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', fileName.replace(/%20/g, ' '))
                link.click()
            }
            setIsLoading(false)
            setIsValidOtp(true)
            setOtp("")
            setErrorCount(0)
            setVerifyOtpError("")
            // }
        }).catch((err) => {
            setIsValidOtp(false)
            setIsLoading(false)
            setErrorCount(errorCount + 1)
            setResendTimer(false)
            const uint8Array = new Uint8Array(err.response.data);
            const decoder = new TextDecoder('utf-8');
            const responseString = JSON.parse(decoder.decode(uint8Array));
            setVerifyOtpError(responseString.error === "invalid otp" ? "Invalid OTP" : responseString.error)
        })
    }

    const getFileName = () => {
        return fileName
    }

    const goBackToEmail = () => {
        setErrorCount(0)
        setIsEmailSent(false)
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const fileid = queryParams.get('id');
        const filename = queryParams.get('fileName');
        setFileName(filename)
        setFileId(fileid)

    }, [])

    useEffect(() => {
        const disableShortcuts = (e: KeyboardEvent) => {
            if (e.ctrlKey && ["p", "s", "u"].includes(e.key.toLowerCase())) {
                e.preventDefault();
            }
            if (e.key === "PrintScreen") {
                navigator.clipboard.writeText("");
                alert("Screenshots are not allowed!");
            }
        };
        const disableRightClick = (e: MouseEvent) => e.preventDefault();

        document.addEventListener("contextmenu", disableRightClick);
        document.addEventListener("keydown", disableShortcuts);
        return () => {
            document.removeEventListener("contextmenu", disableRightClick);
            document.removeEventListener("keydown", disableShortcuts);
        };
    }, []);

    const blobToDataUrl = async (blob: Blob): Promise<string> => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.readAsDataURL(blob);
        });
    };

    return (
        <>{uri ?
            <div className={`w-p-100 ${IsMobileDevice ? "h-p-90" : "h-v-100"}`}>
                <div className={`h-p-90 w-p-90 d-flex justify-center align-center p-relative mx-auto mt-2 ${UtilityService.getSecureFileMediaExtension(fileName).includes("vnd.openxmlformats-officedocument.wordprocessingml.document") ? "" : "b-around-text-field-border-4 br-2"}`} style={{ zIndex: 9999 }}>
                    {
                        UtilityService.getSecureFileMediaExtension(fileName).includes("image") ?
                            <img src={uri} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} className='display-media' />
                            : UtilityService.getSecureFileMediaExtension(fileName).includes("audio") ?
                                <audio src={uri} controls controlsList="nodownload noplaybackrate" ></audio>
                                : UtilityService.getSecureFileMediaExtension(fileName).includes("video") ?
                                    <video src={uri} style={{ width: '100%', height: 'auto', objectFit: 'contain' }} controls controlsList="nodownload noplaybackrate" />
                                    : UtilityService.getSecureFileMediaExtension(fileName).includes("vnd.openxmlformats-officedocument.wordprocessingml.document") ? <div ref={containerRef} className={`${IsMobileDevice ? "docx-container" : ""} h-p-100 o-y-scroll`}></div>
                                        : UtilityService.getSecureFileMediaExtension(fileName).includes("application/pdf") ?
                                            <DocViewer
                                                documents={[{ uri: blob, fileType: "pdf", fileName: fileName }]}
                                                pluginRenderers={DocViewerRenderers}
                                                config={{
                                                    header: {
                                                        disableHeader: true,
                                                    },
                                                    pdfVerticalScrollByDefault: true,
                                                }}
                                                style={{ height: '100%', overflow: 'auto', width: "100%", opacity: isLoading ? 0 : 1 }}
                                            />
                                            : <iframe src={`${uri}#toolbar=0`} className='w-p-100 h-v-98 o-scroll '></iframe>
                    }
                </div>
                <div className='h-p-7 d-flex justify-center align-center'>
                    <LockGrayIcon />
                    <span className='h4-regular mx-1 color-primary-inactive'>File Secured by</span>
                    <FalconLogo className='w-20' /> </div>
            </div>
            : <div className={`w-p-${IsMobileDevice ? "80" : "40"} m-auto login-background br-2 d-flex flex-direction pt-4`}>
                <div className={` mx-auto ${IsMobileDevice ? "" : "w-p-80"}`}>
                    <div className={" w-fill d-flex"}>
                        <FalconLogo
                            width={100}
                            height={50}
                            className="mx-auto"
                        />
                    </div>

                    {!isEmailSent ?
                        <div className={"br-2 px-5"}>
                            <div className={`${IsMobileDevice ? "h5" : "h3-semibold"} color-secure-file-email-filename mb-2 d-flex align-center`}>
                                <span className='mr-2 secure-file-name'>{getFileName()}</span>
                                <DisplayMediaIcon FileName={fileName} />
                            </div>
                            <form onSubmit={(e) => VerifyEmail(e)}>
                                <span>
                                    <label className={`${IsMobileDevice ? "h5" : "h5-medium"} color-primary-accent mb-1`}>
                                        Verify your email to access the file *
                                    </label>
                                    <TextField
                                        error={!!errors.Email}
                                        placeholder="Enter Your Email *"
                                        required
                                        fullWidth
                                        className="mt-1"
                                        value={email}
                                        name="email"
                                        onChange={(e) =>
                                            handleChange(e.target.name, e.target.value)
                                        }
                                        variant="outlined"
                                        autoFocus
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='start' >
                                                    <MessageIcon />
                                                </InputAdornment>)
                                        }}
                                    />
                                    <FormHelperText className={`h5-regular color-primary-danger t-align-right ${!!errors.Email ? "" : "mt-4"}`}>
                                        {errors.Email}
                                    </FormHelperText>
                                </span>
                                < ButtonComponent
                                    ButtonLabel={buttonLabels.NEXT}
                                    Variant={"primary-btn"}
                                    Type={"submit"}
                                    ClassName="w-p-100 justify-center mb-3 h4-regular mb-2"
                                    Loading={showLoader}
                                    ButtonRightIcon={ArrowForwordIcon}
                                />

                                {!!verifyemailerror && verifyemailerror !== "file not found" ?
                                    <div className={`d-flex flex-direction color-primary-danger justify-center h5-regular mb-1`}>
                                        <span >
                                            {appNote.SECURE_FILE_YOU_DONT_HAVE_ACCESS_ERROR}
                                        </span>
                                        <span>
                                            {appNote.SECURE_FILE_YOU_DONT_HAVE_ACCESS_CONTACT_SENDER_ERROR}
                                        </span>
                                    </div>
                                    : !!verifyemailerror &&
                                    <div className={`color-primary-danger justify-center h5-regular d-flex flex-direction align-center mb-1 `}>
                                        <span >
                                            {"The requested file has been deleted by the Sender."}
                                        </span>
                                        <span>
                                            {"Please contact the sender for further assistance. "}
                                        </span>
                                    </div>
                                }
                            </form>
                        </div>
                        :
                        errorCount < 3 ?
                            <SecureFileOtpVerficationComponent
                                StepLength={1}
                                NumOfSteps={4}
                                IsNumberInput={true}
                                HandleOnChangeStepValue={handleOtpChange}
                                Value={otp}
                                ErrorMessage={verifyOtpError}
                                ResendOtp={resendOtp}
                                VerifyOtp={verifyOtp}
                                IsValid={isValidOtp}
                                ResendLabel={" Send Again"}
                                ShowResendTimer={showResendTimer}
                                ResendTime={30}
                                Title={setOtpEmailTitle()}
                                IsLoading={isLoading}
                                WrongAttemptsDisplayMsg={appNote.TWOFACTORAUTH_ERROR}
                                IsUnAuthScreen
                                OtpTextFieldColor={"bg-color-unauth-field"}
                                ButtonLabel={buttonLabels.VERIFY_OTP}
                            />
                            :

                            <div>
                                <div className="d-flex justify-center">
                                    <IncoreectIcon
                                        className={`w-6 h-6`}
                                    />
                                </div>
                                <div className={"mb-1 d-flex justify-center mt-1"}>
                                    <span className={`h2-medium color-display-content t-align-center `}>
                                        {appNote.TWOFACTORAUTH_ERROR}
                                    </span>
                                </div>
                                <div className={"mb-1 d-flex justify-center h4-regular"}>
                                    {"Please try again after some time"}
                                </div>
                                <ButtonComponent ButtonLabel={buttonLabels.BACK_TO_VERIFY_EMAIL} Variant={"primary-btn"} OnClick={() => goBackToEmail()} ClassName={`d-flex justify-center primary-btn mx-auto h4-regular w-p-60`} />
                            </div>
                    }

                    <div className='d-flex justify-center align-center mb-1'>
                        <LockGrayIcon />
                        <span className={`${IsMobileDevice ? "h5" : "h5-regular"}  ml-1`}>{appNote.FILE_SECURED_BY_FALKONSMS}</span>
                    </div>
                </div>
            </div>
        }
        </>
    )
}
export default UnAuthComponent(SecureFileEmailAuthentication);